import styled from 'styled-components';
import Wra16A from 'dc/Wra16A';
import { Typ30, Typ20, Typ42 } from 'dc/Typ';
import Load03 from 'dc/Load03';

export const OuterWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: transparent;
`;
export const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: transparent;
  min-height: 180px;
`;

export const InfoWrapper = styled(Wra16A)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: transparent;
  min-height: 130px;
`;

export const TranslateTitle = styled(Typ42)`
  text-align: center;
`;

export const MainText = styled(Typ30)`
  text-align: center;
`;
export const SubText = styled(Typ20)`
  text-align: center;
`;

export const PlaceholderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const Loader = styled(Load03)`
  background-color: transparent;
  min-height: 310px;
`;
